import { Injectable } from '@angular/core';
import { lastValueFrom, Observable } from 'rxjs';
import {
  Concept,
  ConceptCloneInput,
  ConceptPopulated,
  ConceptsService as ConceptAPIService,
} from 'src/api';

import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {
  AWFFile,
  SnackBarService,
  TableRefreshDataAction,
} from '@ansys-internal/awf-angular/shared';
import {
  ActionContributionsService,
  AWFAction,
} from '@ansys-internal/awf-angular/contributions';
import { DashboardTables } from '@ansys-internal/awf-angular/dashboard';
import { ConceptService } from '../../../app/shared/services/concept.service';

type Input = [design: AWFFile, templateId: string | null];
type Return = ConceptPopulated | Concept;
/*
 * Inject the state service to access the application state.
 * If an action needs to access or update the state,
 * it can be done using the state service.Actions can trigger other actions as well by injecting the action contribution service.
 */
@Injectable({
  providedIn: 'root',
})
export class CreateConceptFromTemplateAction
  implements AWFAction<Input, Return>
{
  // This can be used to track end user operations and can be used to analyze the user behavior.
  readonly reportAnalysis = false;
  readonly solveAPI = environment.ocmUrl;

  constructor(
    private conceptAPIService: ConceptAPIService,
    private conceptService: ConceptService,
    private snackbar: SnackBarService,
    private http: HttpClient,
    private actions: ActionContributionsService
  ) {}

  async execute(input: Input): Promise<Return> {
    const [design, templateId] = input;

    if (!templateId) {
      throw new Error('No templateId found');
    }

    if (!design.designInstanceList) {
      throw new Error('No design instances found');
    }

    const requestData: ConceptCloneInput = {
      old_design_instance_id: templateId,
      new_design_instance_id: design.designInstanceList[0].designInstanceId,
      copy_jobs: false,
    };

    try {
      return await lastValueFrom(
        this.conceptAPIService.copyConceptsCopyPost(
          false,
          requestData,
          design.designId as string
        )
      );
    } catch (error) {
      this.snackbar.error('Failed to copy template:');

      this.conceptService.deleteDesign(design.designId as string).subscribe({
        next: () => {
          this.actions.execute(TableRefreshDataAction, DashboardTables.FILES);
        },
        error: () => {
          this.snackbar.error('Failed to delete design:');
        },
      });

      throw error;
    }
  }
}
